export enum Role {
  CenterUser = 'centerUser', //only upload access
  /**
   * Rights: all access including deleting/adding all anon configs, trials and centers
   * On demotion: will need to be reassigned a center.
   * On create trial: will not automatically become a trial admin. Can set themselves as admin in the trial center config.
   */
  Admin = 'admin', 
  /**
   * Rights: modification access of existing anon configs, trials and centers that they are part of
   * Cannot create any trials or centers or anon configs
   * Can set/remove other users as trial admins
   */
  TrialAdmin = 'trialAdmin' 
}
